import { apiImages } from '@spo/services/api';
import { PostApiPixlSupermodelsImagesBody } from '@spo/types';
import { useQuery } from '@tanstack/react-query';

export const useImagesBySmIds = ({
  smIds,
  offerDate,
  modelData,
  width,
  height,
  contentMediaUrl,
}: PostApiPixlSupermodelsImagesBody) => {
  return useQuery({
    queryKey: ['useImagesBySmIds', smIds, width, height],
    queryFn: () =>
      apiImages.getImages({
        smIds,
        offerDate,
        modelData,
        width,
        height,
        contentMediaUrl,
      }),
    enabled:
      smIds.length > 0 && !!offerDate && modelData && modelData?.length > 0,
  });
};
